export function shouldUpdateScroll({ routerProps }) {
    if (routerProps.location.hash === '#hero') window.scrollTo(0, 0);

    return false;
}
